export default {
  a0: 'Link to superior',
  a1: 'Please enter the upline address',
  a2: 'Submit',
  a3: 'Please use Binance Smart Chain',
  a4: 'Please enter a valid wallet address',
  a5: 'Waiting for on-chain confirmation',
  a6: 'Bound',
  a7: 'Operation failed',
  a8: 'NX Liquidity',
  a9: 'Reward Pool',
  b0: 'Support Pool',
  b1: 'Subscribe to Node',
  b2: 'Node subscription in progress',
  b3: 'Subscribed',
  b4: 'Join Now',
  b5: 'Subscription ended',
  b6: 'Stake',
  b7: 'Participation Amount',
  b8: 'My Balance',
  b9: 'Please enter the amount',
  c0: 'Cost to subscribe to node',
  c1: 'Cancel',
  c2: 'Confirm',
  c3: 'Blockchain confirmation in progress',
  c4: 'Staking successful',
  c5: 'Successfully staked',
  c6: 'Staking Duration (Days)',
  c7: 'Staking Amount',
  c8: 'Daily Yield',
  c9: 'Insufficient balance',
  d0: 'Subscription successful',
  d1: 'Please enter a valid participation amount',
  d2: 'Insufficient available balance',
  d3: 'Outside participation period',
  d4: 'Insufficient gas fees',
  d5: 'Total Orders',
  d6: 'Total Amount',
  d7: 'In Progress',
  d8: 'Pending Redemption',
  d9: 'Completed',
  e0: 'Staked Amount',
  e1: 'Earnings',
  e2: 'Redeem Stake',
  e3: 'No Data',
  e4: 'Loading',
  e5: 'Redeemed',
  e6: 'Home',
  e7: 'Staking History',
  e8: 'Me',
  e9: 'NFT Acquisition Method A',
  f0: 'Invite a total of {num} node users to receive an NFT',
  f1: 'Additional node users to invite',
  f2: '',
  f3: 'NFT Acquisition Method B',
  f4: 'Promote to "V5" level to earn the NFT',
  f5: 'Performance gap for the smaller team',
  f6: 'My NFT',
  f7: 'ID',
  f8: 'Transfer',
  f9: 'Transfer NFT',
  g0: 'Please enter the transfer address',
  g1: 'Please enter a valid transfer address',
  g2: 'Transferred',
  g3: ' is a global prediction platform',
  g4: 'Trade NX',
  g5: 'Not yet available',
  g6: 'CHENXIANG Ecosystem',
  g7: 'Team Bonus Amount',
  g8: 'My Earnings',
  g9: 'View Details',
  h0: 'My Rank',
  h1: 'Node User',
  h2: 'Active User',
  h3: 'Progress to Next Rank ',
  h4: 'Team Performance Needed',
  h5: 'My Community',
  h6: 'Invitation Link',
  h7: 'Copy',
  h8: 'My Upline',
  h9: 'Personal Performance',
  i0: 'Team Performance',
  i1: 'Copied',
  i2: 'Copy Failed',
  i3: 'Earnings History',
  i4: 'Node Referral',
  i5: 'Staking Earnings',
  i6: 'Team Earnings',
  i7: 'Node Release',
  i8: 'Node Dividends',
  i9: 'NFT Dividends',
  j0: '60-Day Staking Reward',
  j1: 'View More',
  j2: 'Staking Reward',
  j3: 'No Permission',
  j4: 'Total Team Performance',
  j5: 'Number of Team Addresses',
  j6: 'Number of Active Team Addresses'
}
